import { Flex } from '@mantine/core';

export function SportybotLogo() {
  return (
    <Flex w={{ base: '120px', md: '188px' }}>
      <svg
        fill="none"
        height="100%"
        viewBox="0 0 188 28"
        width="100%"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.53876 26H20.5388V8H9.53876L1.53876 26Z"
          fill="var(--mantine-color-body)"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M15.5388 1C13.1198 1 11.1027 2.71781 10.6393 5H20.4382C19.9749 2.71781 17.9577 1 15.5388 1Z"
          fill="var(--mantine-color-body)"
          stroke="currentColor"
          strokeWidth="2"
        />
        <mask fill="white" id="path-3-inside-1_1045_20645">
          <path d="M11.5388 14C9.32962 14 7.53876 15.7909 7.53876 18V28H15.5388V18C15.5388 15.7909 13.7479 14 11.5388 14Z" />
        </mask>
        <path
          d="M11.5388 14C9.32962 14 7.53876 15.7909 7.53876 18V28H15.5388V18C15.5388 15.7909 13.7479 14 11.5388 14Z"
          fill="var(--mantine-color-body)"
        />
        <path
          d="M7.53876 28V30H5.53876V28H7.53876ZM15.5388 28H17.5388V30H15.5388V28ZM11.5388 14V16C10.4342 16 9.53876 16.8954 9.53876 18H7.53876H5.53876C5.53876 14.6863 8.22505 12 11.5388 12V14ZM7.53876 18H9.53876V28H7.53876H5.53876V18H7.53876ZM7.53876 28V26H15.5388V28V30H7.53876V28ZM15.5388 28H13.5388V18H15.5388H17.5388V28H15.5388ZM15.5388 18H13.5388C13.5388 16.8954 12.6433 16 11.5388 16V14V12C14.8525 12 17.5388 14.6863 17.5388 18H15.5388Z"
          fill="currentColor"
          mask="url(#path-3-inside-1_1045_20645)"
        />
        <line
          stroke="currentColor"
          strokeWidth="2"
          transform="matrix(-1 0 0 1 19.5388 12)"
          x2="6"
          y1="-1"
          y2="-1"
        />
        <line
          stroke="currentColor"
          strokeWidth="2"
          transform="matrix(-1 0 0 1 19.5388 16)"
          x2="2"
          y1="-1"
          y2="-1"
        />
        <path
          d="M37.4508 24L34.7388 22.032V18.432H40.0428V20.4H44.6028V16.296H37.4508L34.7388 14.328V7.968L37.4508 6H47.1708L49.8828 7.968V11.568H44.6028V9.6H40.0428V13.344H47.1708L49.8828 15.312V22.032L47.1708 24H37.4508ZM52.2934 24V6H64.7254L67.4374 7.968V16.056L64.7254 18.024H57.5974V24H52.2934ZM57.5974 14.424H62.1574V9.6H57.5974V14.424ZM72.2086 24L69.4966 22.032V7.968L72.2086 6H81.9286L84.6406 7.968V22.032L81.9286 24H72.2086ZM74.8006 20.4H79.3606V9.6H74.8006V20.4ZM87.0513 24V6H99.4833L102.195 7.968V16.056L100.011 17.64L102.675 24H96.8913L94.6833 18.024H92.3553V24H87.0513ZM92.3553 14.424H96.9153V9.6H92.3553V14.424ZM108.688 24V9.864H103.768V6H118.912V9.864H113.992V24H108.688ZM125.343 17.472L119.199 6H125.031L128.271 12.672L131.511 6H136.743L130.623 17.472V24H125.343V17.472ZM137.817 24V6H150.249L152.961 7.968V13.56L151.233 14.808L152.961 16.08V22.032L150.249 24H137.817ZM143.121 20.4H147.681V16.296H143.121V20.4ZM143.121 13.344H147.681V9.6H143.121V13.344ZM158.084 24L155.372 22.032V7.968L158.084 6H167.804L170.516 7.968V22.032L167.804 24H158.084ZM160.676 20.4H165.236V9.6H160.676V20.4ZM177.078 24V9.864H172.158V6H187.302V9.864H182.382V24H177.078Z"
          fill="currentColor"
        />
      </svg>
    </Flex>
  );
}
